import { useCallback } from "react";

export const useAttributeFactory = () => {
    const allergyInformation = {
        remap: (values) => {
            return Object.keys(values).reduce((attributeParams, keyName) => {
                const attributeValues = values[keyName];

                if (attributeValues) {
                    const remappedAttributeValues = values[keyName].map((allergyParams) => {
                        if (allergyParams.sub && allergyParams.sub.length) {
                            return {
                                ...allergyParams,
                                sub: [],
                            };
                        }

                        return allergyParams;
                    });

                    return {
                        ...attributeParams,
                        [keyName]: remappedAttributeValues,
                    };
                }

                return {
                    ...attributeParams,
                    [keyName]: values[keyName],
                };
            }, {});
        },
    };

    const remapStrategy = {
        // used to clear "sub" parameters for "allergyInfo" allergens - this should be always empty when sent to the server
        allergyInformation,
    };

    return useCallback((attributeId, values) => {
        const isStrategyProvided = remapStrategy[attributeId];

        if (!!isStrategyProvided) {
            return remapStrategy[attributeId].remap(values);
        }

        return values;
    }, []);
};
